import { QueryClient } from '@tanstack/react-query'

export let queryClient = new QueryClient()
